import { Observable, of, switchMap } from 'rxjs';

import { UserKeys } from '@config/keys/user.keys';
import { DoodUserModel } from '@store/authentication/authentication.model';

/**
 * The Firebase account may already own a DOOD user (Firebase session still active, store user
 * missing). POST /users would then create a second account for the same login, which the API
 * does not match with the Firebase token (403 on orders, DOOD-3495). Reuse it when it exists.
 */
export function reuseExistingAccountOrCreate$<T>(
  existingUser$: Observable<DoodUserModel | undefined>,
  createUser: () => Observable<T>,
  onReuse: (user: DoodUserModel) => void,
): Observable<DoodUserModel | T> {
  return existingUser$.pipe(
    switchMap(existingUser => {
      if (existingUser && !existingUser[UserKeys.IsAnonymous]) {
        onReuse(existingUser);
        return of(existingUser);
      }
      return createUser();
    }),
  );
}
